import { useSelector } from 'src/hooks/useSelector';

const HHTMS = ['resume_search_result', 'resume_search_catalog'];

export const useIsResumeSearchSource = (): boolean => {
    const { hhtmSource, hhtmFrom } = useSelector((state) => state.analyticsParams);
    return HHTMS.includes(hhtmSource) || HHTMS.includes(hhtmFrom);
};
